import { Pops } from "./Pops";

/**
 * O limite de pedidos por minuto do servidor (429): as páginas dos módulos do Construtor (`/m/{slug}`,
 * 120 por minuto) e o Construtor respondem com `{ estado: "erro", codigo: "DEPRESSA_DEMAIS", texto }`
 * (`PedidosDepressaDemais`, no PHP). Antes, um 429 não mostrava nada: os pedidos que não mostram
 * erros (o painel, as listas que se recarregam sozinhas) ficavam calados e as visitas do Inertia
 * paravam sem aviso. Agora o `req.ts` e, no Logigate, o `invalid` do Inertia mostram o texto.
 */
export const CODIGO_DEPRESSA_DEMAIS = "DEPRESSA_DEMAIS";

export const TEXTO_DEPRESSA_DEMAIS = "Estás a ir depressa demais. Espera uns segundos e tenta de novo.";

/** Vários pedidos recusados de seguida (o painel, a fila que se recarrega) dão um aviso só. */
const INTERVALO_ENTRE_AVISOS = 5000;

let ultimoAviso = 0;

/** Mostra o aviso (no máximo um em cada 5 segundos). */
export function avisarDepressaDemais(texto?: string | null): void {
    const agora = Date.now();
    if (agora - ultimoAviso < INTERVALO_ENTRE_AVISOS) {
        return;
    }
    ultimoAviso = agora;
    Pops.error(texto || TEXTO_DEPRESSA_DEMAIS);
}

/** A resposta é a do limite de pedidos do Construtor (e não um 429 com outro sentido, como as tentativas de palavra-passe). */
export function eDepressaDemais(status: number | undefined, dados: unknown): boolean {
    return status === 429 && typeof dados === "object" && dados !== null && (dados as { codigo?: unknown }).codigo === CODIGO_DEPRESSA_DEMAIS;
}
